import React from 'react'
import { useIntl } from 'react-intl'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import CompareIcon from 'LuxKit/Icons/custom/CompareIcon'
import RecordIcon from 'LuxKit/Icons/custom/RecordIcon'
import MatchIcon from 'LuxKit/Icons/custom/MatchIcon'

function useContent() {
  const intl = useIntl()

  return {
    header: {
      title: intl.formatMessage({
        id: 'UkzQGcKsw9',
        defaultMessage: 'Our Best Price Holiday Guarantee',
        description: 'Main heading on the best price guarantee page',
      }),
      subTitle: intl.formatMessage({
        id: 'ctWhQypPIm',
        defaultMessage: 'Luxury Escapes has a Best Price on Earth Holiday Guarantee. If you find a better price online, we’ll match it!',
        description: 'Subtitle explaining the price match promise on the best price guarantee page',
      }),
    },
    negotiation: {
      title: intl.formatMessage({
        id: 'RQiYXA/m3b',
        defaultMessage: 'We negotiate the best prices so you don’t have to',
        description: 'Section heading about price negotiation on the best price guarantee page',
      }),
      subTitle: intl.formatMessage({
        id: '8HzulV3juv',
        defaultMessage: 'Here’s how we do it:',
        description: 'Subtitle introducing the list of how Luxury Escapes negotiates prices',
      }),
      listItems: [
        {
          text: intl.formatMessage({
            id: 'unbN2D6tR5',
            defaultMessage: 'Our global team of experts are dedicated to finding the best holidays for you and your family',
            description: 'First negotiation point about the expert team on the best price guarantee page',
          }),
          icon: <LineCheckIcon colour="primary" />,
        },
        {
          text: intl.formatMessage({
            id: 'nEFvsVO58p',
            defaultMessage: 'We work directly with the top hotels, resorts and cruise brands around the world',
            description: 'Second negotiation point about working with top brands on the best price guarantee page',
          }),
          icon: <LineCheckIcon colour="primary" />,
        },
        {
          text: intl.formatMessage({
            id: 'G/HSeyZVG6',
            defaultMessage: 'Together we curate the best value holiday packages with VIP inclusions so you get more from your escape',
            description: 'Third negotiation point about curating VIP packages on the best price guarantee page',
          }),
          icon: <LineCheckIcon colour="primary" />,
        },
      ],
    },
    howItWorks: {
      title: intl.formatMessage({
        id: 'AdXmVysnvh',
        defaultMessage: 'How Our Best Price Guarantee Works',
        description: 'Section heading for how the best price guarantee process works',
      }),
      subTitle: intl.formatMessage({
        id: 'uCpz1tiYj+',
        defaultMessage: 'In the unlikely event that you find a better price for the same deal, we’ll promise to match it',
        description: 'Subtitle explaining the price match process on the best price guarantee page',
      }),
      items: [
        {
          title: intl.formatMessage({
            id: 'aGEOA8xVnq',
            defaultMessage: 'Compare the Same Deal',
            description: 'First step title in the best price guarantee process',
          }),
          text: intl.formatMessage({
            id: 'ulxFntb9fV',
            defaultMessage: 'Make sure the deal you’ve found is for the same hotel with the same VIP inclusions as our package.',
            description: 'First step description in the best price guarantee process about comparing deals',
          }),
          icon: <CompareIcon colour="primary" size={68} />,
        },
        {
          title: intl.formatMessage({
            id: '9qV5ScOpr+',
            defaultMessage: 'Record the Better Price',
            description: 'Second step title in the best price guarantee process',
          }),
          text: intl.formatMessage({
            id: '18c+EkEFGU',
            defaultMessage: 'Take a website screenshot or a photo of a catalogue so you can send it to us.',
            description: 'Second step description in the best price guarantee process about recording the price',
          }),
          icon: <RecordIcon colour="primary" size={68} />,
        },
        {
          title: intl.formatMessage({
            id: 'zPzwWsV+jL',
            defaultMessage: 'We’ll Match the Price',
            description: 'Third step title in the best price guarantee process',
          }),
          text: intl.formatMessage({
            id: 'v/rGK4avme',
            defaultMessage: 'Once verified we’ll match the price.',
            description: 'Third step description in the best price guarantee process about price matching',
          }),
          icon: <MatchIcon colour="primary" size={68} />,
        },
      ],
    },
  }
}

export default useContent
